import { render } from "./Visores.vue?vue&type=template&id=6457db25"
import script from "./Visores.vue?vue&type=script&lang=js"
export * from "./Visores.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__